import { useCurrentRefinements } from 'react-instantsearch'
import { isEmpty } from 'remeda'
import { useAlgoliaFilters } from '@components/AlgoliaSearch/AlgoliaSearchProvider'
import { SearchResults } from '@components/AlgoliaSearch/SearchResults'
import ApparelCollection, {
  type ApparelCollectionPropsWithHandle,
} from '@components/ApparelCollection/ApparelCollection'
import { CollectionContainer } from '@components/ApparelCollection/styles'

export const ApparelCollectionWithFilterResults = ({
  showProductType,
  categoryHandle,
  skeletonLength,
  groupProducts,
  showSingleVariant,
  collectionTopMessageData,
  className,
  productsCount,
}: ApparelCollectionPropsWithHandle) => {
  const { isSearchActive, searchOnPageLoad } = useAlgoliaFilters()
  const { items } = useCurrentRefinements()

  return !isEmpty(items) || (!isSearchActive && searchOnPageLoad) ? (
    <SearchResults showReviewBadge showProductType={showProductType} />
  ) : (
    <CollectionContainer>
      <ApparelCollection
        showReviewBadge
        className={className}
        categoryHandle={categoryHandle}
        showProductType={showProductType}
        skeletonLength={skeletonLength}
        groupProducts={groupProducts}
        showSingleVariant={showSingleVariant}
        productsCount={productsCount}
        collectionTopMessageData={collectionTopMessageData}
      />
    </CollectionContainer>
  )
}
